<!--
Custom full-width checkbox component with an icon and a slot for the body (usually text).
-->
<template>
  <BaseCheckbox
    v-model="model"
    :input-value="initialValue"
    :disabled="disabled"
    custom>
    <template #default="{ active }">
      <div
        class="wrapper py-md px-lgp gap-lg"
        :class="{ 'active': active }">
        <div class="icon d-flex justify-content-center align-items-center">
          <slot
            name="icon"
            :active="active"/>
        </div>
        <div class="body">
          <slot :active="active"/>
        </div>
        <div class="check">
          <SvgCheck
            v-if="active"
            width="28"
            height="28"/>
        </div>
      </div>
    </template>
  </BaseCheckbox>
</template>

<script setup>
import BaseCheckbox from '../BaseCheckbox.vue'
import SvgCheck from '@/components/global/svg/SvgCheck.vue'

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const model = defineModel({
  type: [Boolean, Array],
  required: true
})

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  initialValue: {
    type: [String, Number, Object],
    required: true
  }
})
</script>

<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;

  .icon {
    :deep(svg) {
      width: 59px;
      height: 59px;

      path {
        stroke-width: 0.5;
      }
    }
  }

  &.active {
    background-color: $origami;

    .icon {
      // Only fill the primary path for icons like svg-case.
      :deep(path) {
        stroke: $primary;

        &:first-of-type {
          fill: $primary;
        }
      }
    }

    .body {
      font-weight: $font-weight-semibold;
    }

    .check {
      width: 28px;
      text-align: right;

      svg {
        stroke: $primary;
      }
    }
  }
}
</style>
